module.exports = __webpack_public_path__ + "media/images/pic/teachers/agata-krukowska-dfcd2a3e78888a7632a0bad6bd693888.webp";